import moment, { Moment as MomentType } from 'moment'
import I18n from 'APP/I18n'

import { DIFFERENCE } from '../constants'

export const dayToReadableText = (date: MomentType, dayToCompare?: MomentType): string => {
  const comparisonDate = dayToCompare ?? moment()
  if (date.isSame(comparisonDate, 'day')) {
    return I18n.t('ConversationScreen.appointmentBanner.today')
  } else if (date.isSame(comparisonDate.clone().subtract('1', 'days'), 'day')) {
    return I18n.t('ConversationScreen.appointmentBanner.yesterday')
  } else if (date.isSame(comparisonDate.clone().add('1', 'days'), 'day')) {
    return I18n.t('ConversationScreen.appointmentBanner.tomorrow')
  } else {
    return date.format('dddd')
  }
}

export const getTimeframeUnit = (dateUntil: moment.Moment, dateFrom: moment.Moment) => {
  if (dateUntil.diff(dateFrom, DIFFERENCE.WEEK) > 1) {
    return DIFFERENCE.WEEK
  } else if (dateUntil.diff(dateFrom, DIFFERENCE.DAY) > 1) {
    return DIFFERENCE.DAY
  }
  return DIFFERENCE.HOUR
}

export const createDays = (dateFrom: moment.Moment, dateUntil: moment.Moment) => {
  const days: moment.Moment[] = []
  let currentDate = dateFrom.clone()
  while (currentDate.isSameOrBefore(dateUntil, 'day')) {
    days.push(currentDate.clone().startOf('day'))

    currentDate = currentDate.add(1, 'days')
  }

  return days
}
